export default "<p>\n  Giovanni Marradi (1852-1922) è stato un poeta, insegnante e scrittore\n  italiano, celebre per temi patriottici e amorosi.\n</p>\n";